import styled from 'styled-components';
import { SECONDARY_COLOR_6 } from '../../const/color';
import { ShareFacebookIcon, ShareInstagramIcon, ShareLinkIcon, ShareTwitterIcon } from '../../const/icons';
import { FAMILY_FONT_EXTRA, TITLE_SIZE_4, TITLE_SIZE_3 } from '../../const/text';
import { device } from '../../const/device';

export const Container = styled.div`
  display: flex;
  padding: 8px;

  width:100%
`;

export const Layout = styled.div`
  position: fixed;
  z-index: 7;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
`;

export const RenderContainer = styled.div<{ image: string }>`
  width: 128px;
  height: 128px;
  background: ${SECONDARY_COLOR_6} url("${props => props.image}") center / 98px auto no-repeat;
  border-radius: 4px;

  background-size: contain;

  @media (${device.tablet}) {
    width: 250px;
    height: 250px;
  }

  @media (${device.tabletS}) {
    width: 128px;
    height: 128px;
  }
`;
export const ContentContainer = styled.div<{preloader:boolean}>`
  margin-left: 8px;
  flex: 1 1 auto;
  opacity:${props => props.preloader ? "0.5" :"1"};
  pointer-events:${props => props.preloader ? "none" :"auto"};

  width:50%;
`;
export const Title = styled.div`
  font-weight: bold;
  font-size: ${TITLE_SIZE_4}px;
  text-align: center;
  margin-top: 31px;
  margin-bottom: 22px;
  color: #000000;
  font-family: ${FAMILY_FONT_EXTRA};
  
  max-width: 100%;

  @media (${device.tablet}) {
    font-size: ${TITLE_SIZE_3}px;
  }

  @media (${device.tabletS}) {
    font-size: ${TITLE_SIZE_4}px;
  }
`;

export const ShareIcon = styled.a<{ color?: string, icon?: string }>`
  cursor: pointer;
  width: 32px;
  height: 32px;
  background: ${params => `${params.color} url("data:image/svg+xml,${params.icon}") center / 16px no-repeat`};
  display: inline-block;
  border-radius: 50%;

  @media (${device.tablet}) {
    width: 42px;
    height: 42px;
  }

  @media (${device.tabletS}) {
    width: 32px;
    height: 32px;
  }
`;
export const ShareIconFacebook = styled(ShareIcon).attrs({ color: '#3B5998', icon: ShareFacebookIcon() })``;
export const ShareIconInstagram = styled(ShareIcon)`
  background: radial-gradient(230.93% 230.93% at 102.01% 2.03%, #F9ED32 0%, #EE2A7B 36%, #D22A8A 44%, #8B2AB2 60%, #1B2AF0 83%, #002AFF 88%);
  transform: rotate(180deg);
  
  &:after {
    content: '';
    width: 100%;
    height: 100%;
    pointer-events: none;
    background: url("data:image/svg+xml,${ShareInstagramIcon()}") center / 16px no-repeat;
    transform: rotate(-180deg);
    position: absolute;
    top: 0;
    left: 0;
  }
`;
export const ShareIconTwitter = styled(ShareIcon).attrs({ color: '#00ACEE', icon: ShareTwitterIcon() })``;
export const ShareIconLink = styled(ShareIcon).attrs({ color: '#000000', icon: ShareLinkIcon() })``;

export const ShareIconContainer = styled.div`
  display: flex;
  justify-content: center;
  > ${ShareIcon}:not(:last-child) {
    margin-right: 16px;
  }
`;
